import { useState } from 'react';
import { subMonths, startOfMonth, addMonths } from 'date-fns';
import { ReactComponent as ArrowLeft } from '../../icons/chevron-left-lg.svg';
import { ReactComponent as ArrowRight } from '../../icons/chevron-right-lg.svg';

import './DatePickerCalendar.scss';
import Calendar from '../Calendar/Calendar';
import { formatDate } from '../../core/helpers';
import Button from '../Button';
interface Props {
  selectedDate?: Date | null;
  onSelect: (d: Date) => void;
  initialDate?: Date;
  name?: string;
}

export default function DatePickerCalendar({
  initialDate,
  selectedDate,
  onSelect,
  name,
}: Props) {
  const [date, setDate] = useState(startOfMonth(initialDate || new Date()));

  const onClickNext = () => {
    setDate((d) => addMonths(d, 1));
  };
  const onClickBack = () => {
    setDate((d) => subMonths(d, 1));
  };

  return (
    <div className='DatePickerCalendar' onClick={(e) => e.stopPropagation()}>
      <div className='row row-cols-auto justify-content-between align-items-center mb-4'>
        <div className='col fw-bold user-select-none'>
          {formatDate(date, 'MMMM yyyy')}
        </div>
        <div className='col'>
          <Button
            styling='naked'
            className='me-2'
            onClick={onClickBack}
            type='button'
          >
            <ArrowLeft />
          </Button>
          <Button styling='naked' onClick={onClickNext} type='button'>
            <ArrowRight />
          </Button>
        </div>
      </div>
      <Calendar
        initialDate={date}
        selectedDate={selectedDate}
        onSelect={onSelect}
        name={name}
      />
    </div>
  );
}
